// extracted by css-extract-rspack-plugin
export default {"spaceLarge":"32px","spaceMedium":"20px","availabilityEmpty":"availability-empty__availabilityEmpty___RMDa5"};